import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full w-auto m-[16px] text-Text/text_high" }
const _hoisted_2 = { class: "row items-center mb-[16px] justify-between" }
const _hoisted_3 = { class: "font-gordita-bold text-[16px] items-center" }
const _hoisted_4 = ["data-testid"]
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = {
  key: 1,
  class: "icon-uil uil-plus text-[20px] mr-[4px]"
}
const _hoisted_7 = {
  class: "flex items-center",
  "data-testid": "api-access--coordinator-id-note"
}
const _hoisted_8 = {
  class: "rounded-sm",
  "data-testid": "api-access--copy-coordinator-id-tooltip"
}
const _hoisted_9 = ["data-testid"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "uil uil-copy text-[16px] ml-1" }, null, -1)
const _hoisted_11 = { class: "relative mt-4 flex flex-col flex-grow" }

import elementIds from '@/const/elementIds.json';
import { computed, inject, ref } from 'vue';
import { IncrediButton, IncrediTooltip, useIncrediDialog, IncrediNote } from 'incredi-ui';
import 'moment-timer';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { useApiAccess } from '@/views/settings/settingsApiAccess/settingsApiAccess.helpers';
import ApiKeysTable from '@/views/settings/settingsApiAccess/components/apiKeysTable.vue';
import { copyToClipboard } from '@/services/utils';
import { CONST_NOTIFY } from '@/services/notify/CONST';
import { useI18n } from 'vue-i18n';
import { useNotify } from '@/services/notify/notify';
import addAPIKeyDialog from './components/addAPIKeyDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'generatedApiKey',
  setup(__props) {

const { GQL_MUTATION_CreateKey } = useApiAccess();
const dialog = useIncrediDialog();
const { t } = useI18n();
const { toastMessage } = useNotify();
const coordinatorsService = inject(IKCoordinatorsService);
const coordinatorId = computed(() => coordinatorsService?.selectedCoordinator.value || '');
const coordTooltip = ref(false);

const handleClickTooltip = (textToCopy: string) => {
  if (textToCopy) {
    copyToClipboard(textToCopy);
    toastMessage(t('generic.copiedToClipboard'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_IbxScopedCss = _resolveComponent("IbxScopedCss")!

  return (_openBlock(), _createBlock(_component_IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('settings.apiAccess.title')), 1),
          _createElementVNode("div", {
            "data-testid": _unref(elementIds).settings.apiKeys.addNewKeyButton
          }, [
            _createVNode(_unref(IncrediButton), {
              design: "primary-green",
              size: "small",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(dialog)?.open('addAPIKeyDialog', addAPIKeyDialog, {})), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  (_unref(GQL_MUTATION_CreateKey).loading.value)
                    ? (_openBlock(), _createBlock(_component_q_spinner, {
                        key: 0,
                        color: "white",
                        size: "16px"
                      }))
                    : (_openBlock(), _createElementBlock("i", _hoisted_6)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.apiAccess.addNewKeyDialog.buttonTitle')), 1)
                ])
              ]),
              _: 1
            })
          ], 8, _hoisted_4)
        ]),
        _createVNode(_unref(IncrediNote), { type: "Information" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.apiAccess.coordinatorId.descriptionA')), 1),
              _createVNode(_unref(IncrediTooltip), {
                direction: "bottom-middle",
                "model-value": coordTooltip.value
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('generic.copiedToClipboard')), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    "data-testid": _unref(elementIds).settings.apiKeys.copyCoordinatorIdButton,
                    class: "text-Text/text_info ml-1.5 font-gordita-medium hover:bg-Hovers/hover_info transition duration-2000 cursor-pointer rounded-sm",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClickTooltip(_unref(coordinatorId))))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.apiAccess.coordinatorId.descriptionB')), 1),
                    _hoisted_10
                  ], 8, _hoisted_9)
                ]),
                _: 1
              }, 8, ["model-value"])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(ApiKeysTable)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})